import React from "react";
import { styled } from "@mui/material/styles";
import Colors from "theme/tokens/colors";
import FileItem from "./file-item";

const FileListContainer = styled("div")``;

const Typography = styled("p")`
  font-size: 14px;
  color: ${(props) => (props.color ? props.color : Colors.BASE_BLACK_500)};
  margin-bottom: 0;
`;

export default function SuccessfulFileList({
  title = "Os arquivos que você quer carregar aparecerão aqui.",
  files = [],
}) {
  return (
    <FileListContainer>
      <Typography>{title}</Typography>
      {files.map((file, i) => (
        <FileItem
          key={`fileitem-${file.name}-${i}`}
          file={file}
          index={i}
          isValid={true}
          isStatic={true}
        ></FileItem>
      ))}
    </FileListContainer>
  );
}
